/* eslint-disable no-nested-ternary */
import React from "react";
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import Icon from "../CommonComponents/CustomIcon";
import { AssestsIcon, IconColors } from "../../Constants/AssetsConstants";

const HelpMenuComponent = ({ open, anchorEl, handleClose }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      onMouseLeave={handleClose}
      BackdropProps={{
        sx: {
          backgroundColor: "#0000004D",
        },
      }}
      PaperProps={{
        elevation: 0,

        onMouseLeave: handleClose,
        style: {
          width: 200,
          backgroundColor: "#e3fff5",
        },

        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          "& .MuiAvatar-root": {
            backgroundColor: "#e3fff5",
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 13,
            width: 10,
            height: 10,
            bgcolor: "#e3fff5",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuItem onClick={() => {}} sx={{ padding: 1 }}>
        <ListItemIcon
          sx={{
            paddingRight: 2,
          }}
        >
          <Icon icon={AssestsIcon.ICON_SUPPORT} size={20} color={IconColors.ICON_BLACK} />
        </ListItemIcon>

        <ListItemText
          primary="Help & Support"
          primaryTypographyProps={{
            fontFamily: "PoppinsMedium",
            color: "#007048",
          }}
          sx={{
            paddingRight: 2,
          }}
        />
      </MenuItem>
      <div className="p-2">
        <p>02110440401</p>
        <p>support@clubtracker.io</p>
      </div>
      <Divider />
      <MenuItem onClick={() => {}} sx={{ padding: 1 }}>
        <ListItemIcon
          sx={{
            paddingRight: 2,
          }}
        >
          <Icon icon={AssestsIcon.ICON_TICKET} size={20} color={IconColors.ICON_BLACK} />
        </ListItemIcon>

        <ListItemText
          primary="Create Ticket"
          primaryTypographyProps={{
            fontFamily: "PoppinsMedium",
            color: "#007048",
          }}
          sx={{
            paddingRight: 2,
          }}
        />
      </MenuItem>
      <MenuItem onClick={() => {}} sx={{ padding: 1 }}>
        <ListItemIcon
          sx={{
            paddingRight: 2,
          }}
        >
          <Icon icon={AssestsIcon.ICON_VIEWTICKET} size={20} color={IconColors.ICON_BLACK} />
        </ListItemIcon>

        <ListItemText
          primary="View Ticket"
          primaryTypographyProps={{
            fontFamily: "PoppinsMedium",
            color: "#007048",
          }}
          sx={{
            paddingRight: 2,
          }}
        />
      </MenuItem>
    </Menu>
  );
};

export default HelpMenuComponent;
